/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * À partir d'un nom de classement complet (ex: "DUPONT Jean, Pierre"),
 * retourne le nom de famille suivi du premier prénom uniquement
 * (ex: "DUPONT Jean").
 *
 * Les prénoms complémentaires sont séparés par des virgules après le premier
 * prénom ("NOM Prénom1, Prénom2, Prénom3, ...") : il suffit donc de ne garder
 * que la partie avant la première virgule, le cas échéant.
 */
const formatNomClassement = (nomClassement?: string | null): string => {
  if (!nomClassement) {
    return '';
  }

  const [premierePartie] = nomClassement.split(',');

  return premierePartie.trim();
};

export default formatNomClassement;
